import { render } from "./ItemQuantitySetter.vue?vue&type=template&id=497c7e6b&scoped=true"
import script from "./ItemQuantitySetter.vue?vue&type=script&lang=js"
export * from "./ItemQuantitySetter.vue?vue&type=script&lang=js"

import "./ItemQuantitySetter.vue?vue&type=style&index=0&id=497c7e6b&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497c7e6b"]])

export default __exports__